function Loader() {
  return null;
}

export default Loader;
